import { useLazyQuery } from '@apollo/client/react';

import { useSpokenPickPortFromQuery } from '@/shared-responder-v2';
import type { SpokenPickExtractionPort } from '@/shared-responder-v2-core';
import { FORMAT_TRANSCRIPT_ANSWER } from '@/survey-graphql';

// test-exception: Apollo binding only — the port and the request shape are useSpokenPickPortFromQuery and toSpokenPickQueryInput, covered by shared-responder-v2-spoken-pick-port.hooks.spec.tsx and shared-responder-v2-spoken-pick.helpers.spec.ts; the literals it sends are checked against survey QuestionType at typecheck.
export function useSurveySpokenPickExtractionPort(): SpokenPickExtractionPort {
  const [formatTranscript] = useLazyQuery(FORMAT_TRANSCRIPT_ANSWER, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  return useSpokenPickPortFromQuery(formatTranscript);
}
